/**
 * The partner program's reads (owner D19, 2026-10-14): ordinary catalog GETs; every write is a named
 * exception in `partner-writes.ts`. Split out of `catalog.ts` on file-size grounds only.
 *
 * The static words (`overview`, `applications`, `earnings`, `fees`, `settings`, `payouts`) are siblings of
 * `/:partnerId`, mirrored in `upstream-siblings.ts` so none can ride the id. `applications` and `payouts`
 * are themselves listed siblings, so the ids beneath them carry their own constrained patterns. Those patterns
 * refuse the literal `compliance-agent`: otherwise `applications/compliance-agent` (a sibling standing in
 * `/:partnerId/compliance-agent`) would ride the application or batch id instead of being refused.
 */
import type { ReadRoute } from "./catalog";

const PAGINATION = ["page", "pageSize"] as const;

export const PARTNER_READ_ROUTES: readonly ReadRoute[] = [
  { path: "/api/admin/partners/overview", query: [] },
  {
    path: "/api/admin/partners/applications",
    query: [...PAGINATION, "status", "search"],
  },
  {
    path: "/api/admin/partners/applications/:id{(?!compliance-agent$)[A-Za-z0-9_-]+}",
    query: [],
  },
  {
    path: "/api/admin/partners/earnings",
    query: [...PAGINATION, "status", "partnerId"],
  },
  { path: "/api/admin/partners/fees", query: [] },
  { path: "/api/admin/partners/settings", query: [] },
  { path: "/api/admin/partners/payouts", query: [...PAGINATION] },
  {
    path: "/api/admin/partners/payouts/:batchId{(?!compliance-agent$)[A-Za-z0-9_-]+}",
    query: [],
  },
  {
    path: "/api/admin/partners",
    query: [...PAGINATION, "status", "search"],
  },
  { path: "/api/admin/partners/:partnerId", query: [] },
  { path: "/api/admin/partners/:partnerId/compliance-agent", query: [] },
];
